export default __webpack_public_path__ + "static/media/under-construction.629d7d48.svg";